import { Injectable } from '@angular/core';
import { BillingProfileDisplayItem } from '@sb/library/data-models';

@Injectable({
    providedIn: 'root'
})
export class MakeupCreditManager {
    GetTotalMakeupCredits(billingProfile: BillingProfileDisplayItem): number {
        return billingProfile.MakeupMinutes / this.GetDefaultLessonDuration(billingProfile);
    }

    GetAvailableMakeupCredits(billingProfile: BillingProfileDisplayItem): number {
        let scheduledMinutes = billingProfile.ScheduledMakeupMinutes ? billingProfile.ScheduledMakeupMinutes : 0;
        return (billingProfile.MakeupMinutes - scheduledMinutes) / this.GetDefaultLessonDuration(billingProfile);
    }

    GetScheduledMakeupCredits(billingProfile: BillingProfileDisplayItem): number {
        let scheduledMinutes = billingProfile.ScheduledMakeupMinutes ? billingProfile.ScheduledMakeupMinutes : 0;
        return scheduledMinutes / this.GetDefaultLessonDuration(billingProfile);
    }

    GetDefaultLessonDuration(billingProfile: BillingProfileDisplayItem): number {
        //Fallback duration 30min because old/legacy data could have LessonDuration 0 or null (spoke with Thom). Fallback prevents, divide by 0 = undefined.
        return billingProfile.LessonDuration > 0 ? billingProfile.LessonDuration : 30;
    }
    GetMakeupCreditsNeededForLesson(billingProfile: BillingProfileDisplayItem, lessonDuration: number) {
        //Case of AllDay has Duration 0, uses the fallback default lesson duration of 30 mins (confirmed with Dan)
        return (lessonDuration > 0 ? lessonDuration : 30) / this.GetDefaultLessonDuration(billingProfile);
    }
}
